import Subsection from '../../../../components/side-panel-information/Subsection';
import TopSection from '../../../../components/side-panel-information/TopSection';
import AdditionalInfo from '../../../../components/side-panel-information/AdditionalInfo';

function FirmInvitationsSidePanel(): JSX.Element {
    return (
        <div className="flex flex-col gap-y-4 lg:w-[300px]">
            <TopSection
                title="Users"
                description={<p>Manage firm members and their access levels, inviting them individually or in bulk.</p>}
            />
            <Subsection
                title="Admin role"
                description="Admins have full control over Cimplico Workpapers and firm settings, including groups, entities, workpapers, templates, users, firm details, integrations and billing."
            />
            <Subsection
                title="Manager role"
                description="Managers have similar access but with restrictions on firm-level integrations and no access to billing & subscription details."
            />
            <Subsection
                title="User role"
                description="Standard users can create groups, entities, and workpapers but have limited access to firm settings."
            />
            <Subsection
                title="External role"
                description="External users are invited from outside the firm to read or edit specific workpapers, without access to other resources beyond their assignment."
            />
            <AdditionalInfo title="Cimplico Workpapers Roles" url="https://support.cimplico.com/en/articles/10244915-firm-user-roles" />
        </div>
    );
}

export default FirmInvitationsSidePanel;
